import { get } from 'lodash';
import { TOGGLE_MODE, LOADING_MODE } from "../actions/types";

const INITIAL_STATE = {
  realtime: false,
  loading: false,
  unavailabilities: false,
  status: false,
  batteryStatus: false,
  atypicalPs: false,
  genericPs: false,
  alarms: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_MODE:
      const realtime = !state.realtime;
      return { ...state, realtime };
    case LOADING_MODE:
      const result = { ...state, loading: action.payload };
      const type = get(action, 'meta.type');
      if (type) {
        result[type] = action.payload;
      }
      return result;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mode_reducer.js